import { citations, reactions, substances } from '@Constants';

const SUBSTANCE_ACCORDION_ITEM_SELECTOR = '.rx-accordion-item';
const SUBSTANCE_ACCORDION_TITLE_SELECTOR = '.rx-accordion-title';
const CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR = 'data-citation-links-tracking-index-marker';
export const CITATION_LINKS_TRACKING_INDEX_MARKER = {
  citationsResultItem: {
    [CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR]: 'citations-result-item',
  },
  reactionsTableItem: {
    [CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR]: 'reactions-table-item',
  },
  substancesTableItem: {
    [CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR]: 'substances-table-item',
  },
};

const getDetailedLocationInSubstances = (element, locationString = '') => {
  const closestAccordionElement = element && element.parentNode.closest(SUBSTANCE_ACCORDION_ITEM_SELECTOR);

  // Traverse up in DOM to find the closest accordion element
  // If found - prepend to locationString and call itself recursively
  if (closestAccordionElement) {
    const accordionTitleElement = closestAccordionElement.querySelector(SUBSTANCE_ACCORDION_TITLE_SELECTOR);
    const accordionTitleTextNode =
      accordionTitleElement && [...accordionTitleElement.childNodes].find((childNode) => childNode.nodeType === Node.TEXT_NODE);
    const titleString = accordionTitleTextNode && accordionTitleTextNode.textContent;
    const updatedLocationString = titleString ? `${titleString.trim().toLowerCase()}:${locationString}` : locationString;

    return getDetailedLocationInSubstances(closestAccordionElement, updatedLocationString);
  }

  // If not - return locationString, trim last colon
  return locationString.replace(/:+$/gi, '');
};

export const getLinkLocation = (linkElement, metadata) => {
  const { context, fromRT } = metadata;

  if (fromRT) {
    return 'retrosynthesis';
  }

  switch (context) {
    case citations:
      return 'results';
    case reactions:
      return 'reaction references';
    case substances:
      return `substances:${getDetailedLocationInSubstances(linkElement)}`;
    default:
      return undefined;
  }
};

export const getLinkIndex = (linkElement) => {
  if (!linkElement) return undefined;

  const closestIndexItem = linkElement.closest(`[${CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR}]`);

  if (!closestIndexItem) return undefined;

  const closestIndexItemMarker = closestIndexItem.getAttribute(CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR);
  const allIndexItems = document.querySelectorAll(`[${CITATION_LINKS_TRACKING_INDEX_MARKER_ATTR}="${closestIndexItemMarker}"]`);
  const linkAbsoluteIndex = [...allIndexItems]
    .filter((el) => {
      // Case when index marker element is hidden on small screen - filter only visually visible elements
      const { width, height } = el.getBoundingClientRect();
      return width > 0 && height > 0;
    })
    .findIndex((el) => el === closestIndexItem);

  return linkAbsoluteIndex !== -1 ? linkAbsoluteIndex + 1 : undefined;
};
